

























































import {Component, Prop, Vue} from "vue-property-decorator";
import { DateTime } from "luxon";
import {Element} from "@api/models/Element";
import { EventInfoData } from "./types/EventInfoData";
import { State } from "./types/StageState";

import { ProgramDataHelper } from "./helpers/ProgramDataHelper"
import { Debounce } from "vue-debounce-decorator";

import InfoPanel from "../info-panel/InfoPanel.vue";
import ObjectLayout from "@service/layouts/ObjectViewLayout.vue";
import Comments from '../comments/components/Comments.vue';
import EventInfo from "./components/event-info/EventInfo.vue";
import ParallelAgendas from "./components/parallel-agendas/ParallelAgendas.vue";
import SessionInfoModal from "./components/parallel-agendas/SessionInfoModal.vue";
import { EventInterface } from "./types/EventInterface";
import EventTypeSelectButton from "@share/common/event-type-select/EventTypeSelectButton.vue";
import AdminPanel from "@share/common/admin-panel/AdminPanel.vue";
import { AdminPanelEventsEnum } from "@share/common/admin-panel/AdminPanelEvents";

/**
 * Компонент для отображения дневного представления программы
 */
@Component({
    name: 'Program',
    components: { AdminPanel, Comments, ObjectLayout, InfoPanel, EventInfo, ParallelAgendas, SessionInfoModal, EventTypeSelectButton }
})
export default class Program extends Vue {

    @Prop({required: true}) backend: string;
    @Prop({required: true}) eventId: string;
    @Prop({required: true}) dataHelper: ProgramDataHelper | null;

    @Prop() pastSessions: EventInterface[];

    State = State;
    infoSessionId: string | null = null;
    infoModalIsShowing = false;

    onNewComment() {
        if (typeof this.dataHelper?.eventComments[this.eventId] === "number") {
            this.dataHelper.eventComments[this.eventId]++;
        }
    }

    showSessionInfo(session: Element) {
        this.infoSessionId = session.id;
        this.infoModalIsShowing = true;
    }

    sortingHandler(a: any, b: any) {
        if (a.beginAt > b.beginAt) {
            return 1;
        }
        if (a.beginAt < b.beginAt) {
            return -1
        }
        return 0;
    }

    get isOnEditing() {
        return this.$store.state.isOnEditing;
    }

    get eventInfoData(): EventInfoData {
        return {
            speakers: this.dataHelper?.eventSpeakers?.[this.eventId] || [],
            partners: this.partners,
            counterObject: this.futureSession
        }
    }

    get showParallelAgendas() {
        return this.sessionsForAnnonce.length || this.hasUpcoming || this.hasPast;
    }

    get hasUpcoming() {
        return this.upcomingSessions.length
    }

    get hasPast() {
        return this.pastSessions.length
    }

    get likes() {
        return this.dataHelper?.eventLikes;
    }

    get selectedEventDescription() {
        return this.selectedEvent?.description || '';
    }

    get lang() {
        return this.$store.state.session?.language || navigator.language.split('-')[0] || "en";
    }

    get selectedEvent(): Element | undefined {
        return this.$store.getters['events/selectedEvent'];
    }

    get commentsCount() {
        return this.dataHelper?.eventComments?.[this.eventId] || 0;
    }

    get speakers() {
        return this.dataHelper?.eventSpeakers?.[this.eventId] || [];
    }

    get partners() {
        return this.exhibitionIds.map((partnerId) => this.dataHelper?.exhibitions?.find((partner) => partnerId === partner.id)).filter(item => item) as Element[]
    }

    get exhibitionIds(): string[] {
        return this.$store.getters['events/exhibitionIds'](this.eventId);
    }

    /**
     * Timezone offset from settings
     */
    get offset() {
        return this.$store.state.timeZoneOffset;
    }

    get eventSchemaId() {
        return process.env.VUE_APP_EVENTS_SCHEMA!;
    }

    get agendaSchemaId() {
        return process.env.VUE_APP_AGENDA_SCHEMA!;
    }

    get eventTitle() {
        return this.$store.getters["events/sortedListByEndDateDesc"]?.find((event: Element) => event.id === this.eventId)?.title || '';
    }

    likeChanged(value: number|null) {
        this.dataHelper?.updateEventLike(value);

        this.setLikes(value);
    }

    @Debounce(500)
    setLikes(value: number|null) {
        this.dataHelper?.setEventLike(value);
    }

    /**
     * events and meetings together, sorted by beginAt
     */
    get mergedList() {
        if (this.dataHelper) {
            let agenda = this.dataHelper.agendaResource ? this.dataHelper.agendaResource : []

            return agenda.sort((a, b) => {
                if (a.beginAt > b.beginAt) {
                    return 1;
                }
                if (a.beginAt < b.beginAt) {
                    return -1
                }
                return 0;
            })
        }
        return [];
    }

    get onlineSessonsList() {
        const now = DateTime.local();
        return this.mergedList.filter((session) => session.beginAt < now && session.endAt > now);
    }

    get onlineUsersCounterId() {
        return 'events/' + this.eventId;
    }

    /**
     * events, sorted by beginAt
     */
    get sessions() {
        return this.dataHelper?.agendaResource ?? [];
    }

    /**
     * all events, sorted by beginAt
     */
    get allFutureAgendas() {
        return this.dataHelper?.allAgendas ?? [];
    }

    private get futureSession() {
        return this.allFutureAgendas?.find((agenda) => {
            const now = DateTime.local();
            const beginAt = typeof agenda.beginAt === "string" ? DateTime.fromISO(agenda.beginAt) : agenda.beginAt;
            return now <= beginAt;
        })
    }

    get upcomingSessions() {
        return this.$store.state.stage.upcomingSessions.filter((session: Element) => !session.isClosed || this.isAdmin).sort(this.sortingHandler);
    }

    get sessionForInfo() {
        return this.upcomingSessions.find((item: Element) => item.id === this.infoSessionId)
    }

    get sessionsForAnnonce() {
        return this.$store.state.stage.sessionsForAnnonce.filter((session: Element) => !session.isClosed || this.isAdmin).sort(this.sortingHandler);
    }

    get isAdmin() {
        return this.$store.getters['isAdmin'];
    }

    get adminPanelEventType() {
        return AdminPanelEventsEnum.eventEvents;
    }
}
